
import { useState } from "react";
import { EditDoorSchedule } from "./EditDoorSchedule";
import { SelectDoorSchedule } from "./SelectDoorSchedule";


export const CommonDoorSchedule: React.FC = ( ) => {
    
    const [ dayCategoryName, setDayCategoryName ] = useState<string>( '' );
    const [ doorCode, setDoorCode ] = useState<string>( '' );
    const [ villageCode, setVillageCode ] = useState<string>( '' );

    const handleDayCategoryNameChange = ( value: string ) => setDayCategoryName( value );
    
    const handleDoorCodeChange = ( value: string ) => setDoorCode( value );

    const handleVillageCodeChange = ( value: string ) => setVillageCode( value );
    
    return(

        <>
            <SelectDoorSchedule 
                onDayCategoryNameChange={ handleDayCategoryNameChange }
                onDoorCodeChange={ handleDoorCodeChange }
                onVillageCodeChange={ handleVillageCodeChange }
            />
            
            {
                ( dayCategoryName && doorCode && villageCode )
                && 
                <EditDoorSchedule 
                    dayCategoryName = { dayCategoryName }
                    doorCode = { doorCode  }
                    villageCode = { villageCode }
                />

            }
           
        </>

    );
};
